import type { Filters } from '../FiltersContext';
import type { IEvent } from '../../';

export const canFilterByEventVenue = (filters: Filters) => filters.selectedEventLocations.length > 0;

export const filterByEventVenue = (filters: Filters) => (event: IEvent) =>
	canFilterByEventVenue(filters) ? filters.selectedEventLocations.includes(event.venue) : true;
